var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('back-to-top',{staticClass:"scroll-top"},[_c('i',{staticClass:"fa fa-angle-up"})])}
var staticRenderFns = []

export { render, staticRenderFns }